export const titleEmergencyProtocol = 'Emergency Protocol';
export const titleAccommodations = 'Accommodations, ADHD, & Medical Leave';
export const titleCampusResources = 'Campus Resources';
export const titleBeaconResources = 'Beacon: Survey Recommended Resources';
export const titleContinuityOfCare = 'Continuity of Care';
export const titleMedical = 'Labs, EKGs, Vitals';
export const titleCareAndCollaboration = 'Care & Collaboration';
